var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons/misc/time",
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,4 C6.6862915,4 4,6.6862915 4,10 C4,13.3137085 6.6862915,16 10,16 C13.3137085,16 16,13.3137085 16,10 C16,8.40870106 15.367859,6.88257758 14.2426407,5.75735931 C13.1174224,4.63214104 11.5912989,4 10,4 Z M10,14.8 C7.3490332,14.8 5.2,12.6509668 5.2,10 C5.2,7.3490332 7.3490332,5.2 10,5.2 C12.6509668,5.2 14.8,7.3490332 14.8,10 C14.8,11.2730392 14.2942872,12.4939379 13.3941125,13.3941125 C12.4939379,14.2942872 11.2730392,14.8 10,14.8 Z M10.528,9.784 L10.528,6.7 C10.528,6.53431458 10.3936854,6.4 10.228,6.4 L9.772,6.4 C9.60631458,6.4 9.472,6.53431458 9.472,6.7 L9.472,10.096 C9.47494944,10.1747321 9.50702117,10.2495662 9.562,10.306 L11.962,12.706 C12.0806882,12.82107 12.2693118,12.82107 12.388,12.706 L12.706,12.388 C12.82107,12.2693118 12.82107,12.0806882 12.706,11.962 L10.528,9.784 Z",
    id: "Icon-color"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.b54b3aa0.svg";
export { ForwardRef as ReactComponent };